import React, { useEffect, useRef, useState } from "react";

/**
 * Click-to-open info tip for settings rows (dark theme popover).
 *
 * @example
 * <SettingsInfoTip
 *   text="Labels AI can assign to your tasks when categorizing them."
 *   label="About task labels"
 * />
 */
const SettingsInfoTip = ({ text, label = "More information" }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handlePointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  return (
    <span className="settings-info-tip" ref={rootRef}>
      <button
        type="button"
        className={`settings-info-tip__btn${open ? " settings-info-tip__btn--open" : ""}`}
        aria-label={label}
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        ⓘ
      </button>
      {open ? (
        <div className="settings-info-tip__popover" role="tooltip">
          {text}
        </div>
      ) : null}
    </span>
  );
};

export default SettingsInfoTip;
